import { RESET_STATE } from 'store/global/actions';

import { PRICE_CONCESSION_ACTION_TYPE } from '../actions';

const initialState = {
  name: null,
  acceptReasons: [],
  rejectReasons: [],
};

const priceConcessionReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case PRICE_CONCESSION_ACTION_TYPE.SET_PRICE_CONCESSION_CONFIGURATION:
      return payload ?? initialState;

    case PRICE_CONCESSION_ACTION_TYPE.RESET_PRICE_CONCESSION_CONFIGURATION:
    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default priceConcessionReducer;
